import LegalLayout from "./LegalLayout";

const CONTACT = "besoindunpro@gmail.com";

export default function DataDeletion() {
  return (
    <LegalLayout slug="data-deletion">
      {/* Bloc résumé Google Play Store — coche les 3 critères exigés */}
      <section className="rounded-2xl border-2 border-pro bg-white p-5 not-prose mb-4" data-testid="data-deletion-summary">
        <div className="text-[10px] uppercase tracking-widest text-pro font-semibold mb-1">Résumé</div>
        <h2 className="font-heading font-bold text-xl text-ink mb-3">
          Suppression de compte — Application <span className="text-brand">Besoin d&apos;un Pro&nbsp;?</span>
        </h2>
        <p className="text-sm text-ink mb-3">
          En tant qu&apos;utilisateur de l&apos;application mobile et du site web
          <strong> Besoin d&apos;un Pro&nbsp;?</strong>, vous pouvez à tout moment demander la
          suppression de votre compte et de toutes vos données associées.
        </p>

        <div className="text-xs font-semibold text-slate2 uppercase tracking-wide mt-4 mb-1">Procédure</div>
        <ul className="list-disc pl-5 space-y-1 text-sm text-ink">
          <li>
            <strong>Depuis l&apos;application</strong>&nbsp;: <em>Profil</em> → bouton
            <strong> « Supprimer mon compte »</strong> → confirmez en saisissant «&nbsp;SUPPRIMER&nbsp;».
            Suppression <strong>immédiate</strong>.
          </li>
          <li>
            <strong>Par e-mail</strong>&nbsp;: écrivez à&nbsp;
            <a href={`mailto:${CONTACT}`} className="text-brand underline">{CONTACT}</a>
            &nbsp;avec l&apos;objet «&nbsp;Suppression de compte&nbsp;». Traité sous 30 jours max.
          </li>
        </ul>

        <div className="text-xs font-semibold text-slate2 uppercase tracking-wide mt-4 mb-1">Données supprimées</div>
        <p className="text-sm text-ink">
          Compte, profil, photos, adresse, ville, numéro SIRET, demandes de travaux, messages,
          devis, avis, historique de jetons et d&apos;abonnements, jetons de notifications push.
        </p>

        <div className="text-xs font-semibold text-slate2 uppercase tracking-wide mt-4 mb-1">Données conservées et durées</div>
        <ul className="list-disc pl-5 space-y-1 text-sm text-ink">
          <li>Bases actives&nbsp;: <strong>suppression immédiate</strong>.</li>
          <li>Sauvegardes techniques (backups)&nbsp;: purge sous <strong>30 jours</strong> maximum.</li>
          <li>Données de facturation (factures émises, obligation comptable)&nbsp;: conservées le temps requis par la loi française, puis supprimées. Aucune donnée de carte bancaire n&apos;est stockée par Besoin d&apos;un Pro&nbsp;?.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-2 mb-3">Option 1 — Supprimer depuis l&apos;application (immédiat)</h2>
        <ol className="list-decimal pl-6 space-y-1">
          <li>Ouvrez l&apos;application <strong>Besoin d&apos;un Pro&nbsp;?</strong> et connectez-vous.</li>
          <li>Allez dans <strong>Profil</strong>.</li>
          <li>Appuyez sur <strong>«&nbsp;Supprimer mon compte&nbsp;»</strong>.</li>
          <li>
            Confirmez. Votre compte et toutes vos données sont supprimés <strong>immédiatement</strong>.
          </li>
        </ol>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">Option 2 — Demander la suppression par e-mail</h2>
        <p>
          Envoyez un e-mail à <a href={`mailto:${CONTACT}`} className="text-brand">{CONTACT}</a> depuis
          l&apos;adresse de votre compte, avec l&apos;objet <strong>«&nbsp;Suppression de compte&nbsp;»</strong>.
          Nous traitons votre demande sous <strong>30 jours</strong> maximum.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">Quelles données sont supprimées&nbsp;?</h2>
        <p>La suppression efface l&apos;ensemble de vos données personnelles&nbsp;:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Compte et profil (nom, e-mail, photo, rôle)</li>
          <li>Données professionnelles (métier, ville, SIRET vérifié, RGE, avis)</li>
          <li>Demandes de travaux publiées et devis reçus</li>
          <li>Messages échangés dans la messagerie interne</li>
          <li>Historique de leads débloqués et jetons restants</li>
          <li>Abonnements en cours (le prélèvement mensuel est stoppé)</li>
          <li>Jetons de notification push et cookies de session</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">Délais de conservation après suppression</h2>
        <div className="overflow-x-auto my-3">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="bg-white border-b border-border">
                <th className="text-left p-2 font-semibold">Donnée</th>
                <th className="text-left p-2 font-semibold">Délai</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-border/50">
                <td className="p-2">Bases de données actives</td>
                <td className="p-2">Suppression immédiate</td>
              </tr>
              <tr className="border-b border-border/50">
                <td className="p-2">Sauvegardes / backups</td>
                <td className="p-2">Purge sous 30 jours maximum</td>
              </tr>
              <tr>
                <td className="p-2">Données légales / comptables (le cas échéant)</td>
                <td className="p-2">Conservées le temps requis par la loi, puis supprimées</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">Abonnement Premium</h2>
        <p>
          La gestion et l&apos;annulation de votre abonnement s&apos;effectuent&nbsp;:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Version Android</strong>&nbsp;: dans <strong>Google&nbsp;Play → Abonnements</strong>.
          </li>
          <li>
            <strong>Version web</strong>&nbsp;: directement depuis l&apos;espace <em>Profil</em> de
            l&apos;application, ou par e-mail à&nbsp;
            <a href={`mailto:${CONTACT}`} className="text-brand">{CONTACT}</a>.
          </li>
        </ul>
        <p>
          Aucune donnée de paiement n&apos;est stockée par Besoin d&apos;un Pro&nbsp;?.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">Contact</h2>
        <p>
          E-mail&nbsp;: <a href={`mailto:${CONTACT}`} className="text-brand">{CONTACT}</a> —&nbsp;
          <a href="/legal/privacy" className="text-brand">Politique de confidentialité</a>
        </p>
      </section>
    </LegalLayout>
  );
}
